
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.7 9.592l3.1-2.41v9.637l-3.1-2.41a1.7 1.7 0 00-1.043-.359H6.7v-4.1h1.957A1.7 1.7 0 009.7 9.592zm4.5-3.433a.9.9 0 00-1.452-.71L8.84 8.487a.3.3 0 01-.184.063H6.1a.8.8 0 00-.8.8v5.3a.8.8 0 00.8.8h2.557a.3.3 0 01.184.063l3.907 3.039a.9.9 0 001.452-.71V6.158zm6.33 8.157a.75.75 0 01-1.06 0l-1.238-1.238-1.237 1.238a.75.75 0 11-1.06-1.06l1.237-1.238-1.238-1.238a.75.75 0 111.06-1.06l1.238 1.237L19.47 9.72a.75.75 0 011.06 1.06l-1.237 1.238 1.237 1.237a.75.75 0 010 1.06z"}})])
          )
        }
      }
    